import React from 'react'
import {Login} from './Login/Login'

export const UnAuthenticatedApp = () => {
  return <Login />
}
